function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#ffcab2}.cls-3{fill:#f26524}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  fill: "#fff",
  d: "M6 0h38a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "customer-representative",
  transform: "translate(8.5 8.283)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1213",
  d: "M33.716 3H23.027A1.431 1.431 0 0 0 21.5 4.5v9.309a1.431 1.431 0 0 0 1.527 1.5h1.527v3.011l4.581-3.005h4.581a1.431 1.431 0 0 0 1.527-1.5V4.5A1.431 1.431 0 0 0 33.716 3z",
  className: "cls-2",
  transform: "translate(-3.743 -1.284)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1214",
  d: "M16510.018 13022.123v-1.955h-1.959c-.336 0-.559-.337-.559-.838s.223-.839.559-.839h1.959v-1.955c0-.336.332-.558.836-.558s.836.222.836.558v1.955h1.957c.332 0 .559.335.559.839s-.227.838-.559.838h-1.957v1.955c0 .333-.332.56-.836.56s-.836-.227-.836-.56z",
  className: "cls-3",
  transform: "translate(-16486.221 -13011.531)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1202",
  fill: "#ef9065",
  d: "M9.992 19.81L4.74 21.569a4.736 4.736 0 0 0-3.24 4.4v3.958h23.464v-4.069a4.736 4.736 0 0 0-3.24-4.4L16.472 19.7h-6.48z",
  transform: "translate(0 1.79)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1203",
  d: "M23.087 29.577v-4.068a4.018 4.018 0 0 0-.67-2.309 5.519 5.519 0 0 0-4.917 5.5v.88h5.587z",
  className: "cls-3",
  transform: "translate(1.877 2.139)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1204",
  d: "M1.5 29.577v-4.068a4.018 4.018 0 0 1 .67-2.309 5.519 5.519 0 0 1 4.916 5.5v.88H1.5z",
  className: "cls-3",
  transform: "translate(0 2.139)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1206",
  d: "M9 16.4v3.629c0 1.759 3.24 3.189 3.24 3.189s3.24-1.429 3.24-3.189V16.4z",
  className: "cls-2",
  transform: "translate(0.88 1.462)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1209",
  d: "M18.691 7.2v5.938a6.079 6.079 0 0 1-6.145 6.048A6.08 6.08 0 0 1 6.4 13.138V7.2",
  className: "cls-2",
  transform: "translate(0.575 0.546)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1211",
  fill: "#4d4d4f",
  d: "M6.6 11.359h.559a.874.874 0 0 0 .894-.88.875.875 0 0 1 .894-.88l1.006.22a8.567 8.567 0 0 0 6.7-1.539.5.5 0 0 1 .782.33v1.869a.875.875 0 0 0 .894.88h.447l.894-2.969a2.193 2.193 0 0 0-2.123-2.639v-.11A2.7 2.7 0 0 0 14.418 3l-6.48 1.1A2.771 2.771 0 0 0 5.7 7.291z",
  transform: "translate(0.49 0.125)"
}));

function SvgColorIconsMedRep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_Med-Rep",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconsMedRep);
export default __webpack_public_path__ + "static/media/color-icons_Med-Rep.abeb1684.svg";
export { ForwardRef as ReactComponent };